<template>
  <footer v-if="!pathMixin_isMeeting && !pathMixin_isMeetingLandingPage" class="footer is-block p-5">
    <div class="content has-text-centered">
      <p class="is-size-7">
        <span class="krungthep">TripCircuit</span> wired for 
        <a href="https://www.ganttravel.com/" target="_blank">Gant Travel Management</a>
      </p>

    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.footer {
  background: none;
}
</style>
